export const API = process.env.REACT_APP_BACKEND;
export const STRIPE_KEY = process.env.STRIPE_KEY;
